module.exports = __webpack_public_path__ + "static/img/headerLogo.d98fd04.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/headerLogo.png
// module id = F3BY
// module chunks = 1